import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=563f8270&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=563f8270&prod&scoped=true&lang=css"
import style1 from "./Role.vue?vue&type=style&index=1&id=563f8270&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f8270",
  null
  
)

export default component.exports